import { WTPayload } from '@f-fertighaus/applications/Next/types/WTPayload'

export const webtrack = (payload: WTPayload) => window._wt(payload)
